<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="col-12" *ngIf="loading">
        <div class="row">
            <div class="col-12">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-12">
            <div class="dash-details-card card-padding-top">
                <app-empty-content [isVisible]="data.length === 0"
                    title="Nenhum histórico encontrado"
                    description="Não foi encontrado nenhum histórico nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>

                <div class="table-scroll-container" *ngIf="data.length > 0">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Fase</th>
                                <th>Usuário</th>
                                <th>Ação</th>
                                <th>Data</th>
                                <th>Observação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of data">
                                <td>{{ getPhaseName(item) }}</td>
                                <td>{{ getUserName(item) }}</td>
                                <td>{{ getAction(item) }}</td>
                                <td>{{ formateDate(item.date) }}</td>
                                <td>{{ handleText(item.reason || '') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>
</ng-container>

<!-- Visualização com comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <div class="row">
        <!-- Lado esquerdo - Versão Principal -->
        <div class="col-6">
            <ng-container *ngIf="approvalService.approvalData.mainVersion">
                <div class="dash-details-card card-padding-top">
                    <app-empty-content [isVisible]="mainData.length === 0"
                        title="Nenhum histórico encontrado"
                        description="Não foi encontrado nenhum histórico nesse cadastro"
                        icon="/assets/images/forgot-password-icon2.png">
                    </app-empty-content>

                    <div class="table-scroll-container"
                        *ngIf="mainData.length > 0">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Fase</th>
                                    <th>Usuário</th>
                                    <th>Ação</th>
                                    <th>Data</th>
                                    <th>Observação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of mainData">
                                    <td>{{ getPhaseName(item) }}</td>
                                    <td>{{ getUserName(item) }}</td>
                                    <td>{{ getAction(item) }}</td>
                                    <td>{{ formateDate(item.date) }}</td>
                                    <td>{{ handleText(item.reason || '') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!approvalService.approvalData.mainVersion">
                <app-select-version-comparison></app-select-version-comparison>
            </ng-container>
        </div>

        <!-- Lado direito - Versão Comparando -->
        <div class="col-6">
            <ng-container *ngIf="approvalService.approvalData.comparingVersion">
                <!-- Skeleton para tabela de histórico -->
                <div class="dash-details-card card-padding-top"
                    *ngIf="comparingDataLoading">
                    <div class="table-scroll-container">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Fase</th>
                                    <th>Usuário</th>
                                    <th>Ação</th>
                                    <th>Data</th>
                                    <th>Observação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let i of [1, 2, 3]">
                                    <td>
                                        <ngx-skeleton-loader [theme]="{
                                            height: '20px',
                                            width: '120px'
                                        }"></ngx-skeleton-loader>
                                    </td>
                                    <td>
                                        <ngx-skeleton-loader [theme]="{
                                            height: '20px',
                                            width: '150px'
                                        }"></ngx-skeleton-loader>
                                    </td>
                                    <td>
                                        <ngx-skeleton-loader [theme]="{
                                            height: '20px',
                                            width: '100px'
                                        }"></ngx-skeleton-loader>
                                    </td>
                                    <td>
                                        <ngx-skeleton-loader [theme]="{
                                            height: '20px',
                                            width: '120px'
                                        }"></ngx-skeleton-loader>
                                    </td>
                                    <td>
                                        <ngx-skeleton-loader [theme]="{
                                            height: '20px',
                                            width: '200px'
                                        }"></ngx-skeleton-loader>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="row" *ngIf="!comparingDataLoading">
                    <div class="col-12">
                        <div class="dash-details-card card-padding-top">
                            <app-empty-content
                                [isVisible]="comparingData.length === 0"
                                title="Nenhum histórico encontrado"
                                description="Não foi encontrado nenhum histórico nesse cadastro"
                                icon="/assets/images/forgot-password-icon2.png">
                            </app-empty-content>

                            <div class="table-scroll-container"
                                *ngIf="comparingData.length > 0">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Fase</th>
                                            <th>Usuário</th>
                                            <th>Ação</th>
                                            <th>Data</th>
                                            <th>Observação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of comparingData"
                                            [class]="item.compareClass">
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <svg-icon
                                                        src="assets/images/icon-check-filled.svg"
                                                        *ngIf="item.compareClass === 'row-compare-added'"
                                                        class="text-success"></svg-icon>
                                                    <svg-icon
                                                        src="assets/images/icon-times-circle.svg"
                                                        *ngIf="item.compareClass === 'row-compare-removed'"
                                                        class="text-danger"></svg-icon>
                                                    <svg-icon
                                                        *ngIf="item.compareClass === 'row-compare-added'"
                                                        src="assets/images/icon-warning.svg"
                                                        class="text-warning"></svg-icon>
                                                    <span
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                        {{ getPhaseName(item) }}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <svg-icon
                                                        src="assets/images/icon-warning.svg"
                                                        *ngIf="item.changedFields?.user"
                                                        class="text-warning"></svg-icon>
                                                    <span
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                        {{ getUserName(item) }}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <svg-icon
                                                        src="assets/images/icon-warning.svg"
                                                        *ngIf="item.changedFields?.action"
                                                        class="fas fa-exclamation-triangle text-warning"></svg-icon>
                                                    <span
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                        {{ getAction(item) }}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <svg-icon
                                                        src="assets/images/icon-warning.svg"
                                                        *ngIf="item.changedFields?.date"
                                                        class="text-warning"></svg-icon>
                                                    <span
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                        {{
                                                        formateDate(item.date)
                                                        }}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <svg-icon
                                                        src="assets/images/icon-warning.svg"
                                                        *ngIf="item.changedFields?.reason"
                                                        class="text-warning"></svg-icon>
                                                    <span
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                        {{
                                                        handleText(item.reason
                                                        || '') }}
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container
                *ngIf="!approvalService.approvalData.comparingVersion">
                <app-select-version-comparison></app-select-version-comparison>
            </ng-container>
        </div>
    </div>
</ng-container>